import {
  Button,
  DatePickerFieldController,
  SelectFieldController,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type BranchOption = {
  value: string;
  label: string;
};

type Props = {
  /** 利用者氏名（「{fullName}の編集」見出しに使用） */
  fullName: string;
  /** 事業所選択肢 */
  branchOptions: BranchOption[];
  /** 更新API実行中フラグ */
  isMutating: boolean;
  /** フォーム送信ハンドラ */
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
  /** キャンセルハンドラ */
  onCancel: React.ComponentProps<typeof Button>['onClick'];
  /** 利用開始日フィールドの編集可否フラグ */
  isBillableFromEditable: boolean;
};

/**
 * 利用者編集フォームの Presentation コンポーネント
 */
export const EditUserFormPresentation: React.FC<Props> = ({
  fullName,
  branchOptions,
  isMutating,
  onSubmit,
  onCancel,
  isBillableFromEditable,
}) => (
  <div className={styles.wrapper}>
    <h1 className={styles.title}>{fullName}の編集</h1>
    <form onSubmit={onSubmit} className={styles.form}>
      <div className={styles.fields}>
        <TextInputFieldController
          name='fullName'
          fieldWrapperProps={{ labelText: '氏名', labelType: 'required' }}
          textInput={{ placeholder: '山田 太郎' }}
        />
        <TextInputFieldController
          name='email'
          fieldWrapperProps={{ labelText: 'メールアドレス', labelType: 'required' }}
          textInput={{ placeholder: 'xxx@example.com', type: 'email' }}
        />
        {branchOptions.length > 0 && (
          <SelectFieldController
            name='branchId'
            fieldWrapperProps={{ labelText: '事業所' }}
            select={{
              placeholder: '事業所を選択',
              options: branchOptions,
              clearable: true,
            }}
          />
        )}
        <DatePickerFieldController
          name='billableFrom'
          fieldWrapperProps={{ labelText: '利用開始日', labelType: 'required' }}
          datePicker={{ disabled: !isBillableFromEditable, fromDate: new Date() }}
        />
        <TextInputFieldController
          name='password'
          fieldWrapperProps={{
            labelText: 'パスワード',
          }}
          textInput={{ type: 'password' }}
        />
        <TextInputFieldController
          name='passwordConfirmation'
          fieldWrapperProps={{ labelText: 'パスワード確認' }}
          textInput={{ type: 'password' }}
        />
      </div>
      <div className={styles.actions}>
        <Button variant='outline' onClick={onCancel} disabled={isMutating}>
          キャンセル
        </Button>
        <Button type='submit' disabled={isMutating}>
          保存
        </Button>
      </div>
    </form>
  </div>
);
